import { PartnerAuthContext } from "app/PartnerAuthContext";
import React from "react";

const usePartnerAuth = () => {
  return React.useContext(PartnerAuthContext);
};

export default usePartnerAuth;
